<template>
  <div class="form-row inline-label payment-methods">
    <div class="form-column">
      <label class="required">{{ $t('paymentSelection.paymentMethodLabel') }}<span v-if="showRequiredIndicator">&nbsp;*</span></label>
      <div v-for="(paymentMethod, key) in paymentMethods" v-show="!isPaymentMethodFree(paymentMethod)" :key="key" class="checkinput">
        <input
          :id="'paymentMethod' + paymentMethod.title"
          :value="paymentMethod.title"
          :class="getClassForPaymentMethod(paymentMethod)"
          :checked="isSelectedPaymentMethod(paymentMethod)"
          type="radio"
          name="paymentOption"
          @click="selectPaymentMethod(paymentMethod)">
        <label :for="'paymentMethod' + paymentMethod.title"
               :class="['payment-method', getClassForPaymentMethod(paymentMethod)]">
          <span>{{ $t('paymentSelection.paymentMethod.' + paymentMethod.title) }}</span>
        </label>
      </div>
      <ul v-if="validation.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
        <li v-if="!validation.required || !validation.validPaymentMethod">{{ $t('paymentSelection.validation.paymentMethod.required') }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { PAYMENT_METHOD_FREE } from '../../types/payment-method'
import authenticationMixin from '../../mixins/authentication'

export default {
  name: 'PaymentMethodSelectionRow',
  mixins: [
    authenticationMixin
  ],
  props: {
    validation: {
      type: Object,
      default: null
    },
    paymentMethods: {
      type: Array,
      default () {
        return []
      }
    },
    selectedPaymentMethod: {
      type: Object,
      default: null
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    }
  },
  mounted: function () {
    if (!this.isStoreUser && !this.selectedPaymentMethod && this.paymentMethods.length) {
      this.$store.dispatch(
        'payment/setSelectedPaymentMethod',
        this.paymentMethods[0]
      )
    }
  },
  methods: {
    isSelectedPaymentMethod: function (paymentMethod) {
      return this.selectedPaymentMethod && paymentMethod.title === this.selectedPaymentMethod.title
    },

    getClassForPaymentMethod: function (paymentMethod) {
      const paymentMethodClassesMap = {
        'sofort': 'directebank'
      }

      return paymentMethodClassesMap[paymentMethod.title]
        ? paymentMethodClassesMap[paymentMethod.title]
        : paymentMethod.title
    },

    selectPaymentMethod: async function (paymentMethod) {
      await this.$store.dispatch('payment/setSelectedPaymentMethod', paymentMethod)
    },
    isPaymentMethodFree: function (paymentMethod) {
      return paymentMethod.title === PAYMENT_METHOD_FREE
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment-selection/PaymentMethodSelectionRow.vue